module.exports = __webpack_public_path__ + "657fd3f6a81fb46ed8c6ec1a69ce34b1.jpg";